export const RECOVERY_STORAGE_KEY = {
  FIND_ACCOUNT_CHANNEL: 'findAccount::channel',
  RESET_PASSWORD_CHANNEL: 'resetPassword::channel',
  RESET_PASSWORD_USERNAME: 'resetPassword::username',
};